import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Card, Col, Row, Typography } from 'antd';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SparingRequestPayload } from 'models/SparingRequests';
import { useParams } from 'react-router-dom';
import { useGetSparingRequestQuery } from 'redux/services/twittlebugs/sparingRequestsApi';
import { useAppSelector } from 'redux/store';
import { colors, toRgba } from 'styles/colors';
const { Text, Title } = Typography;

const styles: InlineStylesModel = {
  header: {
    backgroundColor: toRgba(colors.orangeWeb, 0.4)
  }
};

export const OrderInfoContent = (): JSX.Element => {
  const { values } = useFormikContext<SparingRequestPayload>();
  const { id } = useParams();
  const { user } = useAppSelector((state) => state.app);
  const { data } = useGetSparingRequestQuery(id || skipToken);

  return (
    <Card
      headStyle={styles.header}
      style={{ height: '100%' }}
      title={
        <Title level={4} style={{ fontWeight: 'normal' }}>
          Order Details
        </Title>
      }>
      <Row gutter={16}>
        <Col xs={24} sm={12} xl={8}>
          <Typography.Title level={5} style={styles.infoTitle}>
            Created By:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{id ? data?.createdByFullName : user?.name}</Typography.Paragraph>
          <Typography.Title level={5} style={styles.infoTitle}>
            Created On:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{id ? new Date(data?.createdDateTime || '').toLocaleDateString() : new Date().toLocaleDateString()}</Typography.Paragraph>
          <Typography.Title level={5} style={styles.infoTitle}>
            Contact Number:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{values.contactPhoneNumber || 'n/a'}</Typography.Paragraph>
        </Col>
        <Col xs={24} sm={12} xl={8}>
          <Typography.Title level={5} style={styles.infoTitle}>
            Modified By:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{id ? data?.modifiedByFullName : user?.name}</Typography.Paragraph>
          <Typography.Title level={5} style={styles.infoTitle}>
            Modified On:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{id ? new Date(data?.modifiedDateTime || '').toLocaleDateString() : new Date().toLocaleDateString()}</Typography.Paragraph>
          <Typography.Title level={5} style={styles.infoTitle}>
            Notes:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{values.notes || 'None'}</Typography.Paragraph>
        </Col>

        <Col xs={24} sm={12} xl={8}>
          <Typography.Title level={5} style={styles.infoTitle}>
            Contact Name:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{values.contactName || 'n/a'}</Typography.Paragraph>
          <Typography.Title level={5} style={styles.infoTitle}>
            Contact Email:
          </Typography.Title>
          <Typography.Paragraph style={styles.infoText}>{values.contactEmail || 'n/a'}</Typography.Paragraph>
        </Col>
      </Row>
    </Card>
  );
};
